var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chat-renderer',{ref:"renderer",attrs:{"maxNumber":_vm.config.maxNumber,"showGiftName":_vm.config.showGiftName}})}
var staticRenderFns = []

export { render, staticRenderFns }